/* eslint-disable no-shadow */
import actions from "./actions"
import mutations from "./mutations"

const state = () => ({
  currentEditingModule: [],
  currentModuleID: undefined,
  courseEditingState: {
    moduleEditing: false,
    topicEditing: false,
    postEditing: false,
    moduleCreating: false,
    topicCreating: false,
    postCreating: false,
  },
  currentEditingTopic: {},
  currentTagList: [],
  originalTagList: [],
  deletedTags: [],
  addedTags: [],
  questionStitcherList: [{ name: "", id: "" }],
  megaJSON: [],
  currentEditingReadingObject: {},
  currentEditingQuestion: {},
})

const getters = {
  getCurrentEditingQuestion: state => state.currentEditingQuestion,
  getCurrentEditingReadingObject: state => state.currentEditingReadingObject,
  getMegaJSON: state => state.megaJSON,
  getQuestionStitcherList: state => state.questionStitcherList,
  getAddedTags: state => state.addedTags,
  getDeletedTags: state => state.deletedTags,
  getOriginalTagList: state => state.originalTagList,
  getCurrentTagList: state => state.currentTagList,
  getCurrentEditingTopic: state => state.currentEditingTopic,
  getCurrentModuleID: state => state.currentModuleID,
  getCurrentEditingModule: state => state.currentEditingModule,

  getCurrentCourseEditingStates: state => state.courseEditingState,
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}

export default module
